import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from 'src/app/shared/shared.service';
import { UserRolesEnum } from 'src/app/shared/shared.interface';

export function PatientNoAuthGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const sharedService = inject(SharedService);

    if (sharedService.UserDetail) {
        sharedService.navigateToUrl(`/landing`);
        return false;
    }
    return true;
}


export function PatientAuthGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const sharedService = inject(SharedService);

    const AccessToken = sharedService.AccessToken;
    if (AccessToken) {
        var allowedRoles: any[] = [UserRolesEnum.Subject];
        var access = allowedRoles.indexOf(sharedService.Role) > -1;
        if (!access) {
            sharedService.navigateToLogin(`/login`);
            return false;
        }

        return true;
    }
    sharedService.navigateToLogin(`/login`);
    return false;
}


export function SiteAdminNoAuthGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const sharedService = inject(SharedService);

    if (sharedService.UserDetail) {
        sharedService.navigateToUrl(`/landing`);
        return false;
    }
    return true;
}

export function SiteAdminAuthGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const sharedService = inject(SharedService);

    const AccessToken = sharedService.AccessToken;
    if (AccessToken) {
        var allowedRoles: any[] = [UserRolesEnum.SiteAdministrator];
        var access = allowedRoles.indexOf(sharedService.Role) > -1;
        if (!access) {
            sharedService.navigateToLogin(`/login`);
            return false;
        }

        return true;
    }
    sharedService.navigateToLogin(`/login`);
    return false;
}
